import i18n from '@/langs'
import projectsRu from '@/langs/ru/projects'
import projectsEn from '@/langs/en/projects'
import find from 'lodash-es/find'

// Начальное состояние
const state = {
	projects: {
		ru: projectsRu,
		en: projectsEn,
	},
}

// Синхронные изменения состояний
const mutations = {}

// Геттеры
const getters = {
	projectsByLocale: (state) => {
		return state.projects[i18n.locale]
	},

	projectBySlug: (state) => (slug) => {
		if (!state.projects[i18n.locale] || !slug) return
		let project = find(state.projects[i18n.locale], ['slug', slug])
		if (project) return project
		else return false
	},
}

// Асинхронные изменения
const actions = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
